export const SPANISH_TRANSLATIONS = {
	// MAIN COMPONENTS
	navbar: {
		options: {
			load: {
				title: 'Cargas',
				loads: 'Cargas Iniciales',
				load: 'Subir Archivos',
				status: 'Estado de Carga'
			}
		},
		menu: {
			account: 'Cuenta',
			return: 'Regresar al menú',
			logOut: 'Cerrar sesión'
		}
	},
	landing: {
		instruction: 'Usa este dashboard para poder revisar los archivos que se cargarán al sistema.',
		continue: 'Continuar'
	},

	// FILTERS
	filters: {
		organization: 'Organización',
		workspace: 'Workspace',
		module: 'Módulo',
		submodule: 'Submódulo',
		cycle: 'Ciclo',
		areas: 'Áreas',
		region: 'Región',
		zone: 'Zona',
		depot: 'Depot',
		group: 'Grupo',
		route: 'Ruta'
	},

	// FILE UPLOAD
	loadFile: {
		load: 'Carga de Archivo',
		reviewBtn: 'Cargar',
		msg: {
			loading: 'Cargando archivo...',
			success: 'Archivo cargado correctamente!',
			error: 'Error al cargar archivo, verifica la información y vuelve a intentarlo.'
		}
	},
	loadTypeOptions: {
		restructure: 'Reestructura',
		coordinates: 'Coordenadas',
		cycle: 'Inicial',
		single: 'Adicional'
	},
	loadFileInput: {
		loadType: 'Tipo de carga',
		description: 'Descripción',
		text: 'Haga clic o arrastre un archivo a esta área para cargarlo',
		hint: 'Por favor, asegúrate de que el archivo que adjuntas sea de tipo csv.',
		error: 'Solo se permiten archivos csv.'
	},
	loadForm: {
		create: {
			title: 'Crear Carga',
			msg: {
				success: 'Carga creada correctamente!',
				error: 'Error al crear la carga, por favor intente de nuevo.'
			}
		},
		edit: {
			title: 'Editar Carga',
			msg: {
				success: 'Carga editada correctamente!',
				error: 'Error al editar la carga, por favor intente de nuevo.'
			}
		},
		delete: {
			popconfirm: {
				title: 'Eliminar Carga',
				description: '¿Estás seguro de que quieres eliminar esta carga?',
				confirm: 'Confirmar',
				cancel: 'Cancelar'
			},
			msg: {
				success: 'Carga eliminada correctamente!',
				error: 'Error al eliminar la carga, por favor intente de nuevo.'
			}
		},
		placeholder: {
			organization: 'Selecciona una organización.',
			workspace: 'Selecciona un workspace.',
			module: 'Selecciona un módulo.',
			cycle: 'Selecciona un ciclo.',
			type: 'Selecciona un tipo.',
			load: 'Selecciona una carga.',
			name: 'Ingresa un nombre.',
			description: 'Ingresa una descripción.'
		},
		validationMsg: {
			organization: 'Por favor, selecciona una organización.',
			workspace: 'Por favor, selecciona un workspace.',
			module: 'Por favor, selecciona un módulo.',
			cycle: 'Por favor, selecciona un ciclo.',
			type: 'Por favor, selecciona un tipo.',
			name: 'Por favor, ingresa un nombre.',
			description: 'Por favor, ingresa una descripción.'
		},
		cancel: 'Cancelar'
	},

	// LOAD STATUS
	loadStatus: {
		statusTable: {
			loading: 'Cargando...',
			date: 'Fecha',
			actionButtons: {
				details: 'Ver Detalles',
				confirm: 'Confirmar',
				discard: 'Descartar'
			}
		}
	},
	loadStatusDetails: {
		title: 'Información del Archivo',
		card: {
			source: 'Fuente',
		},
		download: {
			button: 'Descargar',
			validationBtn: 'Validación',
			error: 'Error al descargar el archivo, por favor intente de nuevo.'
		},
		process: {
			button: 'Procesar',
			successSingle: 'Procesando archivo...',
			successMultiple: 'Procesando archivos...',
			errorSingle: 'Error al procesar archivo, por favor intente de nuevo.',
			errorMultiple: 'Error al procesar archivos, por favor intente de nuevo.'
		},
		check: {
			button: 'Validar',
			alert: {
				msg: 'Proceso de validación en curso',
				desc: 'Actualmente, el sistema está validando este archivo. Por favor, regresa más tarde para acceder a la información que será cargada.'
			}
		},
		review: {
			title: 'Resumen de Información',
			noAction: {
				badge: 'S',
				desc: 'Sin Acción'
			},
			creation: {
				desc: 'Creación'
			},
			update: {
				badge: 'A',
				desc: 'Actualización'
			}
		},
		confirm: {
			msg: {
				success: 'El archivo ha sido confirmado para realizar la carga!',
				error: 'Error al confirmar el archivo para realizar la carga!'
			}
		},
		discard: {
			msg: {
				success: 'El archivo ha sido descartado para realizar la carga!',
				error: 'Error al descartar el archivo para realizar la carga!'
			}
		},
		routesSummary: {
			addedLoacations: 'Establecimientos Agregados',
			removedLocations: 'Establecimientos Eliminados'
		},
		validationTitle: 'Proceso de valildación en curso.',
		validationDescription: 'El sistema está validando el archivo conforme a la estructura y reglas establecidas. Este proceso puede tardar unos minutos.',
		validationLoadingStepChecking: 'Verificando archivo',
		validationLoadingStepValidating: 'Aplicando validaciones',
		validationLoadingStepPreparing: 'Preparando resultados',
		validationHistory: {
			title: 'Historial de Validaciones',
			selectHistoryPlaceholder: 'Selecciona una validación',
		},
		movements: {
			title: 'Resumen de Movimientos de Establecimientos',
			location: 'Establecimiento',
			fromRoute: 'Ruta Origen',
			toRoute: 'Ruta Destino',
			new: 'Nuevo',
			route: 'Ruta',
			locationsGained: 'Agregados',
			locationsLost: 'Eliminados',
			netChange: 'Cambio Neto',
			newLocations: 'Nuevos Establecimientos',
			updateLocations: 'Establecimientos Actualizados',
			changedLocations: 'Establecimientos Movidos',
			totalMovements: 'Total de Movimientos',
			searchByCode: 'Buscar por código',
			movementType: 'Tipo de movimiento',
			routesSummary: 'Resumen por Rutas',
			details: 'Detalles',
			detailedMovements: 'Movimientos Detallados',
			noMovements: 'No hay movimientos de establecimientos en este archivo'
		},
		discards: {
			title: 'Resumen de Establecimientos Descartados',
			totalDiscards: 'Total de Descartes',
			reason: 'Motivo de descarte',
			details: 'Detalles',
			noDiscards: 'No hay establecimientos descartados en este archivo'
		}
	},

	// CYCLE INFO
	cycle: {
		title: 'Ciclos',
		loading: 'Cargando ciclos...',
		type: 'Tipo',
		creationDate: 'Fecha de Creación',
		selectStart: 'Fecha de Inicio',
		selectEnd: ' Fecha de Fin',
		start: 'Inicio de ciclo:',
		end: ' Fin de ciclo:',
		workingDays: 'Días laborables:',
		currentDays: 'Días transcurridos:',
		remainingDays: 'Días restantes:',
		routeCycle: {
			msg: {
				error: 'Error al cargar el ciclo de la ruta, por favor intente de nuevo.'
			}
		},
		create: {
			title: 'Crear Ciclo',
			loading: 'Creando ciclo...',
			success: 'Ciclo creado correctamente!',
			error: 'Error al crear el ciclo, por favor intente de nuevo.'
		},
		edit: {
			title: 'Editar Ciclo',
			loading: 'Editando ciclo...',
			success: 'Ciclo editado correctamente!',
			error: 'Error al editar el ciclo, por favor intente de nuevo.'
		},
		startAction: {
			popconfirm: {
				title: 'Empezar Ciclo',
				question: '¿Estás seguro de que quieres empezar este ciclo?',
				description: 'Esta acción empezará el ciclo y las rutas estarán disponibles para los usuarios.',
				confirm: 'Confirmar',
				cancel: 'Cancelar'
			},
			msg: {
				loading: 'Empezando ciclo...',
				success: 'Ciclo empezado correctamente!',
				error: 'Error al empezar el ciclo, por favor intente de nuevo.'
			}
		},
		extend: {
			title: 'Extender Ciclo',
			loading: 'Extendiendo ciclo...',
			success: 'Ciclo extendido correctamente!',
			error: 'Error al extender el ciclo, por favor intente de nuevo.'
		},
		endAction: {
			popconfirm: {
				title: 'Finalizar Ciclo',
				question: '¿Estás seguro de que quieres finalizar este ciclo?',
				description: 'Esta acción finalizará el ciclo y todas las rutas dejarán de estar disponibles para los usuarios.',
				confirm: 'Confirmar',
				cancel: 'Cancelar'
			},
			msg: {
				loading: 'Finalizando ciclo...',
				success: 'Ciclo finalizado correctamente!',
				error: 'Error al finalizar el ciclo, por favor intente de nuevo.'
			}
		},
		delete: {
			popconfirm: {
				title: 'Eliminar Ciclo',
				description: '¿Estás seguro de que quieres eliminar este ciclo?',
				confirm: 'Confirmar',
				cancel: 'Cancelar'
			},
			msg: {
				loading: 'Eliminando ciclo...',
				success: 'Ciclo eliminado correctamente!',
				error: 'Error al eliminar el ciclo, por favor intente de nuevo.'
			}
		},
		placeholder: {
			reference: 'Selecciona una opción.',
		},
		customTime: {
			checkbox: 'Establecer hora de inicio o término',
			startTime: 'Hora de inicio',
			endTime: 'Hora de término',
			timezoneNote: 'Las fechas y horas se registran en el huso horario de la organización: {{timezone}}.',
			timezoneFallback: '(no configurado en la organización, se usa el predeterminado)',
			timezoneLoading: 'Obteniendo huso horario de la organización…',
			format: 'Formato',
			format12h: '12 h',
			format24h: '24 h'
		},
		validationMsg: {
			reference: 'Por favor, selecciona una opción.',
			date: 'Por favor, selecciona la duración del ciclo.',
			startTime: 'Por favor, ingresa la hora de inicio.',
			endTime: 'Por favor, ingresa la hora de término.',
			endBeforeStart: 'La hora de término debe ser posterior a la de inicio.'
		}
	},

	// ORGANIZATION ROUTES
	orgRoutes: {
		loading: 'Cargando rutas...',
		title: 'Rutas'
	},
	routesTable: {
		headers: {
			name: 'Nombre',
			code: 'Código',
			locations: '# Establecimientos',
			status: 'Estado',
			module: 'Módulo',
			user: 'Usuario',
			action: 'Acción'
		}
	},
	routeUpdates: {
		msg: {
			loading: 'Cargando la ruta...',
			success: 'Ruta cargada correctamente!',
			error: 'Error al cargar la ruta!'
		}
	},
	routesMove: {
		button: 'Mover rutas',
		moveError: 'Las rutas no son del mismo grupo, verifica y vuelve a intentarlo.',
		moveGroup: 'No hay grupos disponibles para mover estas rutas. Por favor, cierra este formulario.',
		steps: {
			first: {
				desc:'Selecciona el grupo de destino'
			},
			second: {
				content: {
					title: '¿Seguro que quieres mover estas rutas?',
					from: 'Del grupo:',
					to: 'Al grupo:'
				}
			}
		},
		update: {
			groupsError: 'No se encontró información de los grupos, por favor intente de nuevo.',
			loading: 'Moviendo rutas...',
			success: 'Ruta(s) movidas(s) correctamente!',
			error: 'Error al mover rutas'
		}
	},

	// LOCATIONS
	locations: {
		loading: 'Cargando establecimientos...',
		table: {
			search: {
				search: 'Buscar',
				reset: 'Resetear'
			}
		},
		finishChanges: 'Guardar Cambios',
		move: 'Mover establecimientos'
	},
	locationsUpdates: {
		msg: {
			loading: 'Actualizando información de la tienda...',
			success: 'Información de la tienda actualizada correctamente!',
			error: 'Error al actualizar información de la tienda!'
		}
	},
	locationsMove: {
		steps: {
			first: {
				desc:'Selecciona la ruta de destino'
			},
			second: {
				title: 'Finalizar',
				content: {
					title: '¿Seguro que quieres mover estos establecimientos?',
					from: 'De:',
					to: 'A:',
					back: 'Regresar',
					confirm: 'Confirmar'
				}
			},
			continue: 'Continuar'
		},
		update: {
			routesError: 'No se encontró información de las rutas, por favor intente de nuevo.',
			loading: 'Actualizando establecimientos de la ruta',
			success: 'actualizada correctamente!',
			error: 'Error al actualizar ruta'
		}
	},

	// ERRORS
	errors: {
		title: 'Errores',
		loading: 'Cargando errores...'
	},
	errorForm: {
		inputs: {
			alias: 'Alias',
			value: 'Valor'
		},
		create: {
			title: 'Crear Error',
			msg: {
				success: 'Error creado correctamente!',
				error: 'Error al crear el error, por favor intente de nuevo.'
			}
		},
		edit: {
			title: 'Editar Error',
			msg: {
				success: 'Error editado correctamente!',
				error: 'Error al editar el error, por favor intente de nuevo.'
			}
		},
		delete: {
			popconfirm: {
				title: 'Eliminar Error',
				description: '¿Estás seguro de que quieres eliminar este error?',
				confirm: 'Confirmar',
				cancel: 'Cancelar'
			},
			msg: {
				success: 'Error eliminado correctamente!',
				error: 'Error al eliminar el error, por favor intente de nuevo.'
			}
		},
		placeholder: {
			organization: 'Selecciona una organización.',
			alias: 'Ingresa un alias.',
			name: 'Ingresa un nombre.',
			description: 'Ingresa una descripción.',
			value: 'Ingresa un valor de error.'
		},
		validationMsg: {
			organization: 'Por favor, selecciona una organización.',
			alias: 'Por favor, ingresa un alias.',
			name: 'Por favor, ingresa un nombre.',
			description: 'Por favor, ingresa una descripción.',
			value: {
				required: 'Por favor, ingresa un valor válido de error.',
				min: 'El valor debe ser mayor a 0.'
			}
		},
		cancel: 'Cancelar'
	},

	// SCHEMAS
	schemas: {
		title: 'Esquemas',
		loading: 'Cargando esquemas...'
	},
	schemasForm: {
		inputs: {
			scope: 'Scope',
			value: 'Valor',
			fieldType: 'Tipo de Campo',
			code: 'Código',
			identifier: 'Indentificador',
			primary: 'Primario',
			check: 'Check',
			optional: 'Opcional'
		},
		booleanOptions: {
			true: 'Verdadero',
			false: 'Falso'
		},
		searchName: 'Buscar por nombre', 
		create: {
			title: 'Crear Esquema',
			msg: {
				success: 'Esquema creado correctamente!',
				error: 'Error al crear el esquema, por favor intente de nuevo.'
			}
		},
		edit: {
			title: 'Editar Esquema',
			msg: {
				success: 'Esquema editado correctamente!',
				error: 'Error al editar el esquema, por favor intente de nuevo.'
			}
		},
		delete: {
			popconfirm: {
				title: 'Eliminar Esquema',
				description: '¿Estás seguro de que quieres eliminar este esquema?',
				confirm: 'Confirmar',
				cancel: 'Cancelar'
			},
			msg: {
				success: 'Esquema eliminado correctamente!',
				error: 'Error al eliminar el esquema, por favor intente de nuevo.'
			}
		},
		placeholder: {
			scope: 'Selecciona un scope.',
			value: 'Selecciona un valor.',
			fieldType: 'Selecciona un tipo de campo.',
		},
		validationMsg: {
			scope: 'Por favor, selecciona un scope.',
			value: 'Por favor, selecciona un valor.',
			fieldType: 'Por favor, selecciona un tipo de campo.',
			boolean: 'Por favor, selecciona una opción.',
			namePattern: 'No uses letras con acento (áéíóú ÁÉÍÓÚ ñ Ñ ü Ü)',
		},
		cancel: 'Cancelar'
	},

	// RULES
	rules: {
		title: 'Reglas',
		loading: 'Cargando reglas...'
	},
	rulesForm: {
		inputs: {
			active: 'Activo',
			index: 'Índice',
			type: 'Tipo de condición',
			number: 'Número',
			values: 'Valores',
			actionType: 'Tipo de Acción',
			compoundConditions: 'Condiciones Compuestas',
			operator: 'Operador',
			condition: 'Condición'
		},
		searchName: 'Buscar por nombre', 
		create: {
			title: 'Crear Regla',
			msg: {
				success: 'Regla creada correctamente!',
				error: 'Error al crear regla, por favor intente de nuevo.'
			}
		},
		edit: {
			title: 'Editar Regla',
			msg: {
				success: 'Regla editada correctamente!',
				notModified: 'No se realizaron cambios, realice alguna modificación e intente de nuevo.',
				error: 'Error al editar regla, por favor intente de nuevo.'
			}
		},
		delete: {
			popconfirm: {
				title: 'Eliminar Regla',
				description: '¿Estás seguro de que quieres eliminar esta regla?',
				confirm: 'Confirmar',
				cancel: 'Cancelar'
			},
			msg: {
				success: 'Regla eliminado correctamente!',
				error: 'Error al eliminar regla, por favor intente de nuevo.'
			}
		},
		placeholder: {
			schema: 'Selecciona un esquema.',
			type: 'Selecciona un tipo de condición.',
			values: 'Ingresa los valores para la validación.',
			extraValues: 'Los valores deben de estar separados por comas (e.g. valor1, valor2, valor3).',
			action: 'Selecciona un tipo de acción.',
			compoundConditions: 'Las condiciones compuestas son reglas lógicas complejas que combinan múltiples criterios.'
		},
		validationMsg: {
			index: 'Por favor, ingresa el orden en el que se hará la validación.',
			indexRange: 'El índice debe ser mayor.',
			schema: 'Por favor, selecciona un esquema.',
			type: 'Por favor, selecciona un tipo de condición.',
			number: 'Por favor, ingresa un número.',
			action: 'Por favor, selecciona un tipo de acción!',
			values : 'Por favor, ingresa los valores con el formato correcto.',
		},
		cancel: 'Cancelar'
	},

	// CONFIGURATIONS
	config: {
		title: 'Configuraciones',
		loading: 'Cargando configuraciones...'
	},
	configForm: {
		inputs: {
			bq_project: 'Proyecto BigQuery',
			bq_table: 'Tabla BigQuery',
			bq_table_prefix: 'Prefijo de Tabla BigQuery'
		},
		create: {
			title: 'Crear Configuración',
			msg: {
				success: 'Configuración creada correctamente!',
				error: 'Error al crear la configuración, por favor intente de nuevo.'
			}
		},
		edit: {
			title: 'Editar Configuración',
			msg: {
				success: 'Configuración editada correctamente!',
				error: 'Error al editar la configuración, por favor intente de nuevo.'
			}
		},
		delete: {
			popconfirm: {
				title: 'Eliminar Configuración',
				description: '¿Estás seguro de que quieres eliminar esta configuración?',
				confirm: 'Confirmar',
				cancel: 'Cancelar'
			},
			msg: {
				success: 'Configuración eliminada correctamente!',
				error: 'Error al eliminar la configuración, por favor intente de nuevo.'
			}
		},
		placeholder: {
			bq_project: 'Ingresa un Proyecto BigQuery',
			bq_table: 'Ingresa un Tabla BigQuery',
			bq_table_prefix: 'Ingresa un Prefijo de Tabla BigQuery'
		},
		validationMsg: {
			bq_project: 'Por favor, ingresa un Proyecto BigQuery',
			bq_table: 'Por favor, ingresa un Tabla BigQuery',
			bq_table_prefix: 'Por favor, ingresa un Prefijo de Tabla BigQuery'
		},
		cancel: 'Cancelar'
	},

	// SETTINGS
	settings: {
		title: 'Settings',
		loading: 'Cargando settings...'
	},
	settingsForm: {
		inputs: {
			dailyFrequency: 'Frecuencia Diaria',
			weeklyFrequency: 'Frecuencia Semanal'
		},
		create: {
			title: 'Crear Setting',
			msg: {
				success: 'Setting creada correctamente!',
				error: 'Error al crear la setting, por favor intente de nuevo.'
			}
		},
		edit: {
			title: 'Editar Setting',
			msg: {
				success: 'Setting editada correctamente!',
				error: 'Error al editar la setting, por favor intente de nuevo.'
			}
		},
		delete: {
			popconfirm: {
				title: 'Eliminar Setting',
				description: '¿Estás seguro de que quieres eliminar esta setting?',
				confirm: 'Confirmar',
				cancel: 'Cancelar'
			},
			msg: {
				success: 'Setting eliminada correctamente!',
				error: 'Error al eliminar la setting, por favor intente de nuevo.'
			}
		},
		cancel: 'Cancelar'
	},

	// UTILS COMPONENTS
	buttons: {
		add: 'Agregar',
		reset: 'Resetear',
		search: 'Buscar',
		close: 'Cerrar'
	},
	pagination: {
		rows: '/ página',
		of: 'de'
	},
	copyableText: {
		copy: 'Copiar',
		copied: 'Copiado',
		copyId: 'Copiar ID',
		copiedId: 'ID Copiado'
	},
	statusUpdate: {
		modalTitle: 'Actualizar Estado',
		history: 'Historial',
		noHistory: 'No hay historial',
		options: 'Opciones',
		success: 'Estado actualizado correctamente!',
		error: 'Error al actualizar el estado, por favor intente de nuevo.'
	},

	//BUTTONS
	buttons: {
		reset: 'Resetear',
		search: 'Buscar',
		close: 'Cerrar'
	},

	// STATUS DESCRIPTIONS
	statusDesc: {
		cycle: {
			none: 'None',
			created: 'Creado',
			starting: 'Empezando',
			available: 'Disponible',
			waiting: 'Esperando',
			completed: 'Finalizado',
			removed: 'Eliminado'
		},
		route: {
			none: 'None',
			created: 'Creado',
			available: 'Disponible',
			disabled: 'Deshabilitado',
			removed: 'Eliminado'
		},
		load: {
			none: 'None',
			created: 'Creado',
			review: 'En revisión',
			waiting: 'Esperando',
			processing: 'Procesando',
			good: 'Correcto',
			incomplete: 'Incompleto',
			bad: 'Incorrecto',
			removed: 'Eliminado',
			error: 'Error'			
		},
		loadSource: {
			none: 'None',
			cloud: 'Nube',
			local: 'Local',
			service: 'Servicio',
			other: 'Otro'
		},
		loadScope: {
			none: 'None',
			global: 'Global',
			organization: 'Organización',
			workspace: 'Workspace',
			module: 'Módulo'
		},
		loadFieldType: {
			none: 'None',
			int: 'Número Entero',
			float: 'Número Decimal',
			string: 'Cadena de Texto'
		},
		areaType: {
			locations: 'Establecimientos'
		},
		cycleScope: {
			complete: 'Completo',
			selected: 'Selección'
		},
		ruleFieldType: {
			none: 'None',
			min: 'Menor/Igual que',
			max: 'Mayor/Igual que',
			value: 'Valor',
			other: 'Otro',
			composite: 'Compuesto'
		},
		ruleActionType: {
			none: 'None',
			filter: 'FILTRO',
			exclude: 'EXCLUIR',
			include: 'INCLUIR'
		},
		ruleOperatorType: {
			none: 'None',
			and: 'Y',
			or: 'O',
			not: 'NO'
		},
		new: 'Nuevo',
		update: 'Actualizado',
		changeRoute: 'Movido',
		remove: 'Eliminado',
		newToRoute: 'Nuevo en ruta',
		movementType: {
			new: 'Establecimiento nuevo',
			update: 'Actualización de datos',
			append: 'Agregada a ruta',
			change: 'Cambio de ruta',
			remove: 'Removida de ruta'
		},
		loadWeekday: {
			monday: 'Lunes',
			tuesday: 'Martes',
			wednesday: 'Miércoles',
			thursday: 'Jueves',
			friday: 'Viernes',
			saturday: 'Sábado',
			sunday: 'Domingo'
		},
		discardType: {
			rules: 'Validación fallida',
			inactive: 'Ruta no activa',
			invalid: 'Ruta inválida',
			vectorized: 'Descartado en prefiltro'
		}
	}
};
